import React, { useState } from 'react';
import TabellaLista from '../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../components/Tabella/ChipFilter';

// Valori del filtro a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Attivo', 'Sospeso'];


const StrutturaUtenti = () => {
    const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

    const data_column = [

        {
            Header: 'Data di creazione',
            accessor: 'us_date',
            disableGlobalFilter: true,
        },
        {
            Header: 'Nome utente',
            accessor: 'us_name',
        },

        {
            Header: 'Email',
            accessor: 'us_email',
        },
        {
            Header: 'Ruolo',
            accessor: 'us_role',
        },
        {
            Header: 'Stato',
            accessor: 'us_status',
            disableGlobalFilter: true,
            Cell: ({ value }) => {
                return (
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${value.class}`}></i>
                        {value.label}
                    </div>
                )
            },
            disableFilters: true,
        },
    ];

    const data_json = [
        {
            "id": 1,
            "us_date": "12 novembre 2023",
            "us_name": "Antonio Verdi",
            "us_email": "a.verdi@asdlasportiva.com",
            "us_role": "ADMIN",
            "us_status": {
                "label": "Attivo",
                "class": "text-success",
            }
        },
        {
            "id": 2,
            "us_date": "15 marzo 2024",
            "us_name": "Luisa Ranieri",
            "us_email": "luisaranieri25@gmail.com",
            "us_role": "MKT gestore",
            "us_status": {
                "label": "Sospeso",
                "class": "text-primary",
            }
        },
        {
            "id": 3,
            "us_date": "20 aprile 2024",
            "us_name": "Marco Valdo",
            "us_email": "marco.valdo@asdlasportiva.com",
            "us_role": "gestore Impianti",
            "us_status": {
                "label": "Attivo",
                "class": "text-success",
            }
        }
    ];

    const filteredData = data_json.filter((row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.us_status?.label));

    return (
        <>
            <TabellaLista
                pageList={true}
                cardTitle={'Utenti gestionale'}
                hasSearch={true}
                searchPlaceholder={'Cerca per nome, email o ruolo'}
                hasFilter={false}
                filterControl={
                    <div className="sid-chip-filters">
                        <ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
                    </div>
                }
                hasAddMore={true}
                labelAddMore={'Aggiungi'}
                linkAddMore={'/struttura/strumenti/aggiungi_utente'}
                data_column={data_column}
                data_json={filteredData}
            />
        </>

    )
}

export default StrutturaUtenti